import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  showLabel: {
    id: 'searchVehicleInfo.showLabel',
    defaultMessage: 'Näytä',
  },
  searchLabel: {
    id: 'searchVehicleInfo.searchLabel',
    defaultMessage: 'Hae',
  },
})
